module.exports = __webpack_public_path__ + "src/img/bottom.814576fa.png";